import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import styled, { ThemeProvider } from "styled-components";
import { theme } from "../public/theme";
import { Link } from "react-router-dom";

import { useSelector, shallowEqual, useDispatch } from "react-redux";

import {
  SG_FETCH_SLACK_SCHEDULER,
  SLACK_SCHEDULER_CLEAR_UPDATES,
} from "constants/actions";

import SlackEmployees from "./SlackEmployees";
import SearchEmployees from "./SearchEmployees";
import CurrentEmployees from "./CurrentEmployees";
import SlackEvents from "./slackEvents";

const SlackSchedulerDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [selectSlackSheduler, setSelectedSlackScheduler] = useState(false);
  const [showMessages, setShowMessages] = useState(false);
  const {
    get_slack_scheduler,
    get_surveystructure,
    get_employee,
    get_employee_slack,
  } = useSelector(
    (state) => ({
      get_errors: state.errors,
      get_slack_scheduler: state.slack_scheduler,
      get_surveystructure: state.surveystructure.survey_structure,
      get_employee: state.employees,
      get_employee_slack: state.employee_slack.employee_slack,
    }),
    shallowEqual
  );

  useEffect(() => {
    setSelectedSlackScheduler(get_slack_scheduler?.[id]);
  }, [dispatch, get_slack_scheduler, id]);

  useEffect(() => {
    setShowMessages(get_slack_scheduler?.message);
  }, [dispatch, get_slack_scheduler]);

  useEffect(() => {
    if (get_slack_scheduler?.updated) {
      // Reset the created information
      dispatch({ type: SLACK_SCHEDULER_CLEAR_UPDATES });
      setTimeout(() => {
        if (id) {
          // Redirect to details page
          dispatch({ type: SG_FETCH_SLACK_SCHEDULER, payload: { id } });
        }
      }, 1000);
    }
  }, [get_slack_scheduler, navigate, dispatch, id]);

  useEffect(() => {
    dispatch({ type: SG_FETCH_SLACK_SCHEDULER, payload: { id } });
  }, [dispatch, id]);

  const handleCloseMessage = () => {
    setShowMessages(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <DetailsContainer>
        <h1>
          <LinkButton to={`/leader/audit/slack-scheduler`}>
            {`< Back to List`}
          </LinkButton>{" "}
          Slack Scheduler Details
        </h1>
        {selectSlackSheduler ? (
          <Details>
            <DetailItem>
              <strong>Name:</strong> {selectSlackSheduler.name}
            </DetailItem>
            <DetailItem>
              <strong>Bot:</strong> {selectSlackSheduler.slack_bot?.name}
             <p> <strong>Desc:</strong> {selectSlackSheduler.slack_bot?.description}</p>
            </DetailItem>
            <DetailItem>
              <strong>Status:</strong> {selectSlackSheduler.status}
            </DetailItem>
            <DetailItem>
              <strong>Schedule Type:</strong>{" "}
              {selectSlackSheduler.schedule_type}
            </DetailItem>
            <DetailItem>
              <strong>Alert Time:</strong> {selectSlackSheduler.alert_time}
            </DetailItem>
            <DetailItem>
              <strong>Timezone:</strong> {selectSlackSheduler.timezone}
            </DetailItem>
            <DetailItem>
              <strong>Schedule Specs:</strong>{" "}
              {JSON.stringify(selectSlackSheduler.schedule_specs)}
            </DetailItem>
            <DetailItem>
              <strong>
                Last Triggered (if no history then this is set up date):
              </strong>{" "}
              {selectSlackSheduler.last_triggered}
            </DetailItem>
            <DetailItem>
              <strong>Next Trigger:</strong>{" "}
              {selectSlackSheduler?.next_run_datetime}
            </DetailItem>
            <DetailItem>
              <strong>Additional Data:</strong>{" "}
              {JSON.stringify(selectSlackSheduler.additional_data)}
            </DetailItem>
            <LinkButton
              to={`/leader/audit/slack-scheduler/edit/${selectSlackSheduler.id}`}
            >
              Edit
            </LinkButton>
          </Details>
        ) : (
          <p>Loading...</p>
        )}
      </DetailsContainer>
      {showMessages && (
        <MessageContainer>
          <pre>{JSON.stringify(showMessages)}</pre>
          <CloseButton onClick={handleCloseMessage}>Close</CloseButton>
        </MessageContainer>
      )}
      <SlackEmployees
        organizationGroupId={selectSlackSheduler?.organization_group}
      />
      <SearchEmployees
        organizationGroupId={selectSlackSheduler?.organization_group}
      />
      <CurrentEmployees get_slack_scheduler={selectSlackSheduler} />

      <SlackEvents get_slack_scheduler={selectSlackSheduler} />
    </ThemeProvider>
  );
};

export default SlackSchedulerDetails;

const DetailsContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
`;

const Details = styled.div`
  margin-top: 20px;
`;

const DetailItem = styled.div`
  margin-bottom: 10px;
`;

const LinkButton = styled(Link)`
  display: inline-block;
  margin-top: 10px;
  margin-right: 10px;
  padding: 5px 10px;
  background-color: #007bff;
  color: white;
  text-decoration: none;
  border-radius: 5px;

  &:hover {
    background-color: #0056b3;
  }
`;

const MessageContainer = styled.div`
  margin: 20px 0;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  color: white;
  background-color: rgb(24, 3, 3);
`;

const CloseButton = styled.button`
  margin-top: 10px;
  padding: 5px 10px;
  background-color: rgb(240, 145, 138);
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #c82333;
  }
`;
